import axios from "axios";
//const apiBaseURL =
//	process.env.REACT_APP_API_URL || `${window.location.origin}/api`;


const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

// Create an Axios instance with default configurations
const http = axios.create({
	baseURL: `${apiBaseURL}/api/v1/`,
	timeout: 30000,
	withCredentials: false,
	headers: {
		"Content-Type": "application/json",
	},
});

// Request Interceptor: Add authorization token to headers if available
http.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		console.error("Request Error:", error);
		return Promise.reject(error);
	}
);

// Response Interceptor: Handle responses globally (e.g., for token expiration)
http.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response) {
			if (error.response.status === 401) {
				console.error("Unauthorized! Redirecting to login...");
			}
		} else {
			console.error("Network error or no response received:", error.message);
		}
		return Promise.reject(error);
	}
);

export default http;
